import Checkbox from '@components/checkbox';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import { ChangeEvent } from 'react';

import { TReverseMode, TReverseParam, reverseParams } from 'constants/extraParams';
import { useStore } from 'hooks/useStore';

import { ADR } from '../ADR';

import css from './ReverseGroup.module.css';

interface ReverseGroupProps {
  mode: TReverseMode;
  params: TReverseParam[];
  title?: string;
  className?: string;
}

const ReverseGroup = ({ mode, params, title, className }: ReverseGroupProps) => {
  const {
    app: { i18n },
    ui: { isMobile },
    filter: {
      extraParams: { reverse },
    },
  } = useStore();

  const isExclude = mode === 'exclude';

  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    reverse.setMode(event.target.value as TReverseParam, mode);

  const list = (
    <div className={cn(css.group, className)}>
      {params.map(param => {
        const selected = reverse.modes[param] === mode;

        return (
          <div key={param} className={css.param}>
            <Checkbox
              {...(isExclude ? { cross: selected } : { checked: selected })}
              data-qa={`reverse-${mode}-${param}`}
              size={isMobile ? 'm' : 's'}
              value={param}
              onChange={handleChange}
            >
              {i18n.extraParams.reverse.options[param]}
            </Checkbox>

            {param === reverseParams.adr && selected && !isExclude && <ADR className={css.ADR} />}
          </div>
        );
      })}
    </div>
  );

  if (!title) return list;

  return (
    <div className={css.container}>
      <p className={cn(css.title, 'glz-p', isMobile ? 'glz-is-size-1' : 'glz-is-size-3')}>{title}</p>
      {list}
    </div>
  );
};

const connected = observer(ReverseGroup);

export { connected as ReverseGroup };
